import React from "react";
import ReactGA from "react-ga";
import {AlertBoxComponent} from "./../Common/AlertBoxComponent";

import "./../../css/contact.css";

const NONE = "none";
const SUCCESS = "success";
const ERROR = "error";
const DISABLED = "disabled";
const ERR_MSG_MISSING_FIELDS = "You have one or more required fields with empty value.";
const ERR_MSG_INVALID_EMAIL = "Please enter a valid email address."
const ERR_MSG_TIMEOUT = "You have just sent me couple of messages moments ago! Please give me some time to read them. You may retry later.";
const FAILURE_MSG = 'An unexpected error has occurred! Please try again or email me directly at "wilsonngphotography @ gmail.com" (no spaces). Sorry for the inconveniences.';
const SUCCESS_MSG = "Thank you for contacting me! I will be in touch within 2 business days!";

// const CLIENT_INFO_EXPIRATION = 86400000; // 24 Hours
const SEND_MAIL_EXPIRATION = 600000;     // 10 Minutes
const MAIL_COUNT = "mc";

var setCookie = require("./../Common/utils.js").setCookie;
var getCookie = require("./../Common/utils.js").getCookie;
// var serialize = require("./../Common/utils.js").serialize;

export class ContactComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            // ip: "",
            // location: "",
            name: "",
            email: "",
            phone: "",
            subject: "",
            message: "",
            alert: NONE,
            alertMsg: "",
            buttonClass: ""
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSendMail = this.handleSendMail.bind(this);

        // TODO - test
        //setCookie("sendMail", "true", 30000); // 30 seconds expiration
    }

    componentWillMount() {
        // let ip = getCookie("ip");
        // let location = getCookie("location");
        //
        // let that = this;
        // if (!ip) {
        //     // attempt to get client info
        //     fetch("https://freegeoip.net/json/").then(function(response) {
        //         if (response.ok) {
        //             return response.json();
        //         }
        //     }).then(function(json) {
        //         const newLocation = json.city + ", " + json.region_name + ", " + json.country_name + ", " + json.zip_code;
        //
        //         that.setState({
        //             ip: json.ip,
        //             location: newLocation
        //         });
        //
        //         // setCookie
        //         setCookie("ip", json.ip, CLIENT_INFO_EXPIRATION); // 1 day
        //         setCookie("location", newLocation, CLIENT_INFO_EXPIRATION + 10000); // 1 day + 10 secs (latency)
        //     }).catch(function(error) {
        //         that.setState({
        //             ip: "Failed to Retrieve",
        //             location: "Failed to Retrieve"
        //         });
        //     });
        // } else {
        //     that.setState({
        //         ip: ip,
        //         location: location
        //     });
        // }
    }

    handleChange(event) {
        switch (event.target.id) {
            case "name":
                this.setState({name: event.target.value});
                break;
            case "email":
                this.setState({email: event.target.value});
                break;
            case "phone":
                this.setState({phone: event.target.value});
                break;
            case "subject":
                this.setState({subject: event.target.value});
                break;
            default:
                this.setState({message: event.target.value});
                break;
        }
        event.preventDefault();
    }

    async handleSendMail(event) {
        event.preventDefault();
        const that = this;

        if (this.state.buttonClass === DISABLED) {
            // still sending; do not send duplicates
            return;
        }

        this.setState({alert: NONE, alertMsg: "", buttonClass: DISABLED});

        // start validation
        if (this.state.name.trim() === "" || this.state.email.trim() === "" || this.state.subject.trim() === "" || this.state.message.trim() === "") {
            this.setState({alert: ERROR, alertMsg: ERR_MSG_MISSING_FIELDS, buttonClass: ""});
            // Tracking
            ReactGA.event({
                category: "SendMail",
                action: "Validation",
                // label: "error-send-mail-missing-field-value from: " + that.state.ip.trim()
                label: "error-send-mail-missing-field-value"
            });
            return;
        }

        if (!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.state.email.trim()))) {
            this.setState({alert: ERROR, alertMsg: ERR_MSG_INVALID_EMAIL, buttonClass: ""});
            // Tracking
            ReactGA.event({
                category: "SendMail",
                action: "Validation",
                // label: "error-send-mail-invalid-email from: " + that.state.ip.trim()
                label: "error-send-mail-invalid-email"
            });
            return;
        }

        // Check mail count
        const mailCount = getCookie(MAIL_COUNT);

        if (mailCount) {
            const mailCountValue = parseInt(mailCount, 10);
            if (mailCountValue >= 2) {
                this.setState({alert: ERROR, alertMsg: ERR_MSG_TIMEOUT, buttonClass: ""});
                // Tracking
                ReactGA.event({
                    category: "SendMail",
                    action: "MaxMailCount",
                    // label: "error-send-mail-max-mail-count from: " + that.state.email.trim()
                    label: "error-send-mail-max-mail-count"
                });
                return;
            }
        }

        // everything looks good, try to send mail
        const reqHeaders = new Headers({
            "Content-Type": "application/json",
            "Accept": "application/json"
        });

        const data = {
            // "ip": this.state.ip.trim(),
            // "location": this.state.location,
            "name": this.state.name.trim(),
            "email": this.state.email.trim(),
            "_subject": "Wilson Ng Photography - " + this.state.subject.trim(),
            "phone": this.state.phone.trim(),
            "message": this.state.message.trim(),
            "_format": "plain",
            "_gotcha": document.getElementById("age").value
        }

        const reqInit = {
            method: "POST",
            headers: reqHeaders,
            mode: "cors",
            body: JSON.stringify(data)
        };

        try {
            const response = await fetch("https://formspree.io/wilsonngphotography@gmail.com", reqInit);
            if (response.ok) {
                that.setState({
                    name: "",
                    email: "",
                    phone: "",
                    subject: "",
                    message: "",
                    alert: SUCCESS,
                    alertMsg: SUCCESS_MSG,
                    buttonClass: ""
                });
                // add mail count to cookie
                if (mailCount) {
                    let mailCountValue = parseInt(mailCount, 10) + 1;
                    setCookie(MAIL_COUNT, mailCountValue, SEND_MAIL_EXPIRATION);
                } else {
                    setCookie(MAIL_COUNT, 1, SEND_MAIL_EXPIRATION);
                }

                // Tracking
                ReactGA.event({
                    category: "SendMail",
                    action: "Send",
                    // label: "successful-send-mail from: " + that.state.email.trim()
                    label: "successful-send-mail"
                });

            } else {
                throw new Error(FAILURE_MSG);
            }

        } catch (err) {
            that.setState({alert: ERROR, alertMsg: FAILURE_MSG, buttonClass: ""});
            // Tracking
            ReactGA.event({
                category: "SendMail",
                action: "Error",
                label: "error-send-mail-failed"
            });
        }
    }

    render() {
        let alert = "";
        if (this.state.alert === SUCCESS) {
            alert = <AlertBoxComponent type={this.state.alert} message={this.state.alertMsg} icon="fa fa-paper-plane" />;
        } else if (this.state.alert === ERROR) {
            alert = <AlertBoxComponent type={this.state.alert} message={this.state.alertMsg} />;
        }

        return (
            <section id="contact-component">
                <div className="header">Contact</div>
                <div className="message-box">
                    Thank you for visiting my site! It is my pleasure to hear your feedback and answer any questions you may have.
                    <br />
                    <br />
                    Hope you enjoyed viewing my photos! If you like any of them, you may be pleased to know that all photos displayed in my gallery are available for print purchase and licensing.
                    Just fill up this form or email me directly at <strong>wilsonngphotography @ gmail.com</strong> for more details or if you have any special request.
                </div>
                <div className="content-box">
                    <form-group>
                        <prompt>Name</prompt>
                        <input type="text" id="name" name="name" value={this.state.name}
                         onChange={this.handleChange} placeholder="Enter Your Name" />
                        <input type="text" id="age" name="age" value="" />
                    </form-group>
                    <form-group>
                        <prompt>Email Address</prompt>
                        <input type="text" id="email" name="email" value={this.state.email}
                         onChange={this.handleChange} placeholder="Enter Email Address" />
                    </form-group>
                    <form-group>
                        <prompt>Phone</prompt>
                        <input type="text" id="phone" name="phone" value={this.state.phone}
                         onChange={this.handleChange} placeholder="Enter Phone (optional)" />
                    </form-group>
                    <form-group>
                        <prompt>Subject</prompt>
                        <input type="text" id="subject" name="subject" value={this.state.subject}
                         onChange={this.handleChange} placeholder="Enter Subject" />
                    </form-group>
                    <form-group>
                        <prompt>Message</prompt>
                        <textarea id="message" name="message" value={this.state.message}
                         onChange={this.handleChange} rows="6" placeholder="Enter Message" />
                    </form-group>
                    <form-group>
                        {alert}
                        <button className={this.state.buttonClass} onClick={this.handleSendMail}>Send Mail</button>
                    </form-group>
                </div>
            </section>
        );
    }
}



// WEBPACK FOOTER //
// ./src/widgets/Scroll/ContactComponent.js